var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Books',
        to: '/ebooks'
      }, {
        label: ("Bulk Update File " + (this.slug)),
        to: ("/items/bulk/upload/" + (this.slug))
      }, {
        label: 'Log Activity'
      }],
      "title": "Log Activity"
    }
  }), _c('div', {
    staticClass: "border rounded-xl overflow-hidden mb-5"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.items,
      "withNumberCol": false,
      "row-key": ['created_at', 'total_items', 'created_by'],
      "current-page": _vm.currentPage,
      "isLoading": _vm.isLoading,
      "per-page": 15
    },
    scopedSlots: _vm._u([{
      key: "header-date",
      fn: function (_ref) {
        var column = _ref.column;
        return [_c('div', {
          staticClass: "flex justify-between items-center gap-1 px-3"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "actions",
      fn: function (_ref2) {
        var row = _ref2.row;
        return [_c('div', {
          staticClass: "tooltip-wrapper"
        }, [_c('div', {
          staticClass: "w-20 cursor-pointer text-right flex justify-end relative -top-1 right-2",
          class: {
            'opacity-50 pointer-events-none': row.status === 0
          },
          on: {
            "click": function ($event) {
              return _vm.goToDetail(row);
            }
          }
        }, [_c('svg', {
          staticClass: "w-5 h-5 text-gray-500 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M4.998 7.78C6.729 6.345 9.198 5 12 5c2.802 0 5.27 1.345 7.002 2.78a12.713 12.713 0 0 1 2.096 2.183c.253.344.465.682.618.997.14.286.284.658.284 1.04s-.145.754-.284 1.04a6.6 6.6 0 0 1-.618.997 12.712 12.712 0 0 1-2.096 2.183C17.271 17.655 14.802 19 12 19c-2.802 0-5.27-1.345-7.002-2.78a12.712 12.712 0 0 1-2.096-2.183 6.6 6.6 0 0 1-.618-.997C2.144 12.754 2 12.382 2 12s.145-.754.284-1.04c.153-.315.365-.653.618-.997A12.714 12.714 0 0 1 4.998 7.78ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
            "clip-rule": "evenodd"
          }
        })])]), row.status === 0 ? _c('span', {
          staticClass: "tooltip-box"
        }, [_vm._v(" Your request is being processed. ")]) : _vm._e()])];
      }
    }, {
      key: "created_at",
      fn: function (_ref3) {
        var value = _ref3.value;
        return [_c('p', {
          staticClass: "px-3"
        }, [_vm._v(_vm._s(_vm.formatDate(value)))])];
      }
    }, {
      key: "created_by",
      fn: function (_ref4) {
        var value = _ref4.value;
        return [_c('p', {
          staticClass: "text-left lowercase"
        }, [_vm._v(_vm._s(value))])];
      }
    }, {
      key: "total_items",
      fn: function (_ref5) {
        var value = _ref5.value;
        return [_c('p', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(value))])];
      }
    }])
  }), !_vm.isLoading && _vm.items.length ? _c('div', {
    staticClass: "flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t border-gray-100 mt-0"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.items.length) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": 15
    },
    on: {
      "change": _vm.onClickPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }